import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';
import { EsmeModel } from '../../models/esmeModel';
import { convertVersionableIdToString } from '../../types/versionableId';
import { esmeFetchAllFailureAction, esmeFetchAllRequestAction, esmeFetchAllSuccessAction } from './esmeActions';
import { EsmeStateModel } from './esmeStateModel';

export const esmeAdapter = createEntityAdapter<EsmeModel>({
  selectId: esmeModel => convertVersionableIdToString(esmeModel.id),
});

const initialState: EsmeStateModel = esmeAdapter.getInitialState({
  loading: false,
  errors: [],
});

export const esmeReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(esmeFetchAllRequestAction, (state) => {
      state.loading = true;
      state.errors = [];
    })
    .addCase(esmeFetchAllSuccessAction, (state, action) => {
      state.loading = false;
      esmeAdapter.setAll(state, action.payload);
    })
    .addCase(esmeFetchAllFailureAction, (state, action) => {
      state.loading = false;
      state.errors = [...state.errors, action.payload];
    });
});
